import React, { Component } from 'react';
import { Route } from 'react-router';
import { withRouter } from 'react-router-dom';

import { AppBase } from '@instacarro/ic-webapp-admin-components/dist/containers';
import TimerIcon from '@material-ui/icons/Timer';
import CarIcon from '@material-ui/icons/DirectionsCar';

import Appointments from '@instacarro/ic-webapp-admin-hub-react-appointments';
import Cars from '@instacarro/ic-webapp-admin-hub-react-cars';

import { SESSION_KEY } from '@instacarro/ic-webapp-admin-core/dist/constants';
import { services, defaultAuthProvider } from '@instacarro/ic-webapp-admin-components/dist/common/appIsolatedContext';

class App extends Component {
  state = {
    loadingSession: true,
  }

  componentDidMount() {
    defaultAuthProvider.changeState = (newSession) => {
      if (!newSession) {
        return defaultAuthProvider.doLogin();
      }
      this.setState({
        loadingSession: false,
      });
      return null;
    };

    const session = window.localStorage.getItem(SESSION_KEY) || null;
    defaultAuthProvider.setSession(JSON.parse(session));
  }

  onNavClick = (event, nav) => {
    this.props.history.push(nav.path);
  };

  render() {
    if (this.state.loadingSession) {
      return (<div>Loading ...</div>);
    }

    return (
      <div className="App">
        <AppBase
          navItems={[
            {
              label: 'Agendamentos',
              path: '/appointments',
              icon: (<TimerIcon />),
              onNavClick: this.onNavClick,
            },
            {
              label: 'Versões de carros',
              path: '/cars',
              icon: (<CarIcon />),
              onNavClick: this.onNavClick,
            },
          ]}
        >
          <div>
            <Route path="/appointments" render={props => (<Appointments {...props} venuesService={services.venuesService} authProvider={defaultAuthProvider} />)} />
            <Route path="/cars" render={props => (<Cars {...props} specificationsService={services.specificationsService} authProvider={defaultAuthProvider} />)} />
          </div>
        </AppBase>
      </div>
    );
  }
}

export default withRouter(App);
export const AppComponent = App;



// WEBPACK FOOTER //
// ./src/App.js